import { makeStyles } from '@material-ui/core';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const styles = makeStyles(_theme => ({
  '@global': {
    'body.keyboard-disable-enter .keyboardButton-enter': {
      opacity: '0.4',
    },
  },
}));
